// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"_cc230d5","hidden":"_9630bab","styledModal":"_8d1d833"};